import PubSub from 'pubsub-js';

const IMAGE_PREVIEW = 'IMAGE_PREVIEW';

export const emitImagePreview = url => {
  PubSub.publish(IMAGE_PREVIEW, url);
};

export const subscribeImagePreview = cb => {
  const token = PubSub.subscribe(IMAGE_PREVIEW, (msg, data) => cb(data));

  return () => {
    PubSub.unsubscribe(token);
  };
};



// WEBPACK FOOTER //
// ./src/utils/events/imagePreview.js